export const statsData = [
  {
    count: 1,
    title: 'Rabi 24',
    label: 'Total Nos. of State Agency',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/officer-white.png',
    link: '',
    sort_order: '1',
    background_color: '#f2f2f2',
    primary_text_color: '#3498db',
    secondary_text_color: '#70b9e8',
    main_entity: '1',
    state_entity: '0',
    district_entity: '0',
    society: '0',
    pc_center: '0'
  },
  {
    count: 594,
    title: 'Rabi 24',
    label: 'Total Nos. of Society',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/officer-white.png',
    link: '',
    sort_order: '3',
    background_color: '#f2f2f2',
    primary_text_color: '#3498db',
    secondary_text_color: '#70b9e8',
    main_entity: '1',
    state_entity: '1',
    district_entity: '1',
    society: '0',
    pc_center: '0'
  },
  {
    count: 132,
    title: 'Rabi 24',
    label: 'No. of Mills',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/officer-white.png',
    link: '',
    sort_order: '2',
    background_color: '#f2f2f2',
    primary_text_color: '#3498db',
    secondary_text_color: '#70b9e8',
    main_entity: '1',
    state_entity: '1',
    district_entity: '0',
    society: '0',
    pc_center: '0'
  },
  {
    count: 120,
    title: 'Rabi 24',
    label: 'Quantity Transferred to Mill (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/officer-white.png',
    link: '',
    sort_order: '2',
    background_color: '#f2f2f2',
    primary_text_color: '#3498db',
    secondary_text_color: '#70b9e8',
    main_entity: '1',
    state_entity: '1',
    district_entity: '0',
    society: '0',
    pc_center: '0'
  }
];

export const cfsp = [
  {
    count: 886,
    title: 'Rabi 24',
    label: 'Depots',
    icon: '',
    link: '',
    sort_order: '0',
    background_color: '',
    primary_text_color: '',
    secondary_text_color: ''
  },
  {
    count: 4016168,
    title: 'Rabi 24',
    label: 'Capacity (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#71f9a6',
    secondary_text_color: '#666565'
  },
  {
    count: 0,
    title: 'Rabi 24',
    label: 'Opening Balance (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 0,
    title: 'Rabi 24',
    label: 'Quantity Received (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 0,
    title: 'Rabi 24',
    label: 'Quantity Issues (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 0,
    title: 'Rabi 24',
    label: 'Quantity Dispatch (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 0,
    title: 'Rabi 24',
    label: 'Stock Position (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  }
];
export const cfppData = [
  {
    count: 733432,
    title: 'All',
    label: 'Farmers Registered',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#71f9a6',
    secondary_text_color: '#666565'
  },
  {
    count: 289913,
    title: 'All',
    label: 'Farmers Benefitted',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 877190.45,
    title: 'All',
    label: 'Quantity Procured (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 148734,
    title: 'All',
    label: 'MSP Benefitted Farmers',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 107777.32,
    title: 'All',
    label: 'MSP Payment Made (in Lac.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 1077.78,
    title: 'All',
    label: 'MSP Payment Made (in Cr.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 551380,
    title: 'Markfed',
    label: 'Farmers Registered',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#71f9a6',
    secondary_text_color: '#666565'
  },
  {
    count: 222609,
    title: 'Markfed',
    label: 'Farmers Benefitted',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 679989.12,
    title: 'Markfed',
    label: 'Quantity Procured (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 136175,
    title: 'Markfed',
    label: 'MSP Benefitted Farmers',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 98943.14,
    title: 'Markfed',
    label: 'MSP Payment Made (in Lac.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 989.43,
    title: 'Markfed',
    label: 'MSP Payment Made (in Cr.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 182042,
    title: 'TDC',
    label: 'Farmers Registered',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#71f9a6',
    secondary_text_color: '#666565'
  },
  {
    count: 66482,
    title: 'TDC',
    label: 'Farmers Benefitted',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 195031.88,
    title: 'TDC',
    label: 'Quantity Procured (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 5475,
    title: 'TDC',
    label: 'MSP Benefitted Farmers',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 4210.86,
    title: 'TDC',
    label: 'MSP Payment Made (in Lac.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 42.11,
    title: 'TDC',
    label: 'MSP Payment Made (in Cr.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  }
];
export const additionalData = [
  {
    count: '',
    title: 'Rabi 24',
    label: '',
    icon: '',
    link: '',
    sort_order: '0',
    background_color: '',
    primary_text_color: '',
    secondary_text_color: ''
  },
  {
    count: 612583,
    title: 'Rabi 24',
    label: 'Farmers Registered',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#71f9a6',
    secondary_text_color: '#666565'
  },
  {
    count: 135294,
    title: 'Rabi 24',
    label: 'Farmers Benefitted',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 442931.44,
    title: 'Rabi 24',
    label: 'Quantity Procured (MT)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 15502,
    title: 'Rabi 24',
    label: 'MSP Benefitted Farmers',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  },
  {
    count: 12252.84,
    title: 'Rabi 24',
    label: 'MSP Payment Made (in Lac.)',
    icon: 'https://ansio-solutions.s3.ap-south-1.amazonaws.com/assets/images/field-white.png',
    link: '',
    sort_order: '13',
    background_color: '#fafafa',
    primary_text_color: '#e04a09',
    secondary_text_color: '#666565'
  }
];
export const chartData = [
  {
    label: 'MOCK FPC',
    value: '2247.61',
    drilldown_value: '0',
    tooltip: '2,247.61MT'
  },
  {
    label: 'Beam Society',
    value: '3444.47',
    drilldown_value: '0',
    tooltip: '3,444.47MT'
  },
  {
    label: 'DMO Nashik mock Soc Babarao',
    value: '176.60',
    drilldown_value: '0',
    tooltip: '176.60MT'
  },
  {
    label: 'VS soc2',
    value: '168.90',
    drilldown_value: '0',
    tooltip: '168.90MT'
  },
  {
    label: 'SunSociety',
    value: '114.90',
    drilldown_value: '0',
    tooltip: '114.90MT'
  }
];

export const dropdowndata = [
  {
    id: '1',
    value: 'Rabi 24',
    type: 'season_calendar_name'
  },
  {
    id: '2',
    value: 'Kharif 24',
    type: 'season_calendar_name'
  }
];
export const comoditydropdowndata = [
  {
    id: '1',
    value: 'Rabi 24',
    type: 'season_calendar_name'
  },
  {
    id: '2',
    value: 'Kharif 24',
    type: 'season_calendar_name'
  }
];
